export default __webpack_public_path__ + "static/media/kravetsLogo.dc6f92e2.svg";